import type {
    SearchResultSetV1,
    SubstrateSearchResponseV1,
} from '../../data/schema/SubstrateSearchResponse';
import type { ResultSet, SubstrateSearchQueryResponse } from '@1js/3s-schema';
import { logUsage } from 'owa-analytics';

export default function getSearchResultSet(
    responseBody: SubstrateSearchQueryResponse | SubstrateSearchResponseV1
): ResultSet | SearchResultSetV1 {
    const entitySetsCount = responseBody?.EntitySets?.length ?? 0;
    const resultSetsCount = responseBody?.EntitySets?.[0]?.ResultSets?.length ?? 0;

    if (entitySetsCount !== 1 || resultSetsCount !== 1) {
        /* eslint-disable-next-line owa-custom-rules/telemetry-mailboxinfo-as-second-param -- (https://aka.ms/OWALintWiki)
         * BASELINE: DO NOT COPY/PASTE!
         *	> Argument at index 1 for logUsage must be of type MailboxInfo and not undefined. Telemetry calls that violate this rule will eventually be removed by the framework team. https://aka.ms/owa-analytics-mailboxinfo */
        logUsage('SearchResult_InvalidResultSet', undefined, {
            EntitySetsCount: entitySetsCount,
            ResultSetsCount: resultSetsCount,
        });
    }

    if (responseBody?.EntitySets?.[0]?.ResultSets?.[0]) {
        return responseBody.EntitySets[0].ResultSets[0];
    }

    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2322 (14,5): Type 'null' is not assignable to type 'SearchResultSet'.
    // @ts-expect-error
    return null;
}
